















































































// Vue
import { Vue, Prop, Component } from 'vue-property-decorator'

// utils
import { getFullNameFormat } from '@/utils'

// models
import { PropOptionSelect } from '@/models'
import { WorkDescriptionModel, EmployeeModel } from '@/models/config'
import { FiltersDailyControlModel } from '@/models/dailyControl'

// components
import { Select2, DatePicker } from '@/components/form'

@Component({
  name: 'FilterDailyControl',
  components: {
    Select2,
    DatePicker
  }
})
export default class FilterDailyControl extends Vue {
  @Prop({ type: Array, default: () => [] }) employees!: EmployeeModel[]
  @Prop({ type: Array, default: () => [] }) workDescriptions!: WorkDescriptionModel[]

  description_id: number|string = ''
  employee_id: number|string = ''
  date_init = ''
  date_end = ''

  get descriptionsOp (): PropOptionSelect[] {
    return this.workDescriptions.map(w => {
      return {
        value: w.id,
        text: w.name
      }
    })
  }

  get employeesOp (): PropOptionSelect[] {
    return this.employees
      .filter(employee => employee.is_active)
      .map(employee => ({
        value: employee.id ?? null,
        text: getFullNameFormat(employee)
      }))
  }

  get canSubmit (): boolean {
    if ((this.date_init !== '' && this.date_end !== '') && this.date_init > this.date_end) {
      return false
    }
    return true
  }

  cleanFilters () {
    this.description_id = ''
    this.employee_id = ''
    this.date_init = ''
    this.date_end = ''
    this.changeFlters()
  }

  changeFlters () {
    const filters: FiltersDailyControlModel = {
      employee_id: this.employee_id,
      workDescription_id: this.description_id,
      date_init: this.date_init,
      date_end: this.date_end
    }
    this.$emit('change-filter', filters)
  }

  toFilter () {
    this.$emit('filter')
  }
}
